import { useContext } from "react";

import { ApiKeysContext } from "../contexts";

export function useApiKeys() {
  const context = useContext(ApiKeysContext);

  return context;
}
